import React from 'react'
import { IntrigrationSec } from './intrigrationSec'

export const IntrigrationSubscriptionsResponseCodes = () => {
  return (
    <>
    <IntrigrationSec /> 
    </>
  )
}
